module.exports = __webpack_public_path__ + "static/media/diploma.69b026cb.svg";